export enum FilingType
    {
        Standard_Rule,
        Emergency_Rule,
        Misc_Rule,
        Agency,
        Title,
        Nonsubstantive        
    };